import {
  formatLocalDateTimeInputValue,
  localDateTimeInputValueToIso,
} from './formatters.ts';

interface LocalDateTimeInputProps {
  readonly label: string;
  readonly value: string;
  readonly placeholder?: string;
  readonly inputClassName?: string;
  readonly testId?: string;
  readonly onChange: (value: string) => void;
  readonly formatValue?: (value: string | null | undefined) => string;
  readonly parseValue?: (value: string) => string;
}

const BASE_INPUT_CLASS =
  'rounded-md border border-line-soft bg-canvas px-3 py-2 text-body normal-case tracking-normal text-paper max-md:min-h-10 max-md:text-field-touch';

export function LocalDateTimeInput({
  label,
  value,
  placeholder,
  inputClassName = '',
  testId,
  onChange,
  formatValue = formatLocalDateTimeInputValue,
  parseValue = localDateTimeInputValueToIso,
}: LocalDateTimeInputProps): JSX.Element {
  return (
    <label className="flex flex-col gap-1 text-label font-medium text-paper-low">
      {label}
      <input
        type="datetime-local"
        step={60}
        value={formatValue(value)}
        placeholder={formatValue(placeholder ?? '')}
        onChange={(event) => onChange(parseValue(event.currentTarget.value))}
        className={`${BASE_INPUT_CLASS} ${inputClassName}`.trim()}
        data-testid={testId}
      />
    </label>
  );
}
